<template>
  <div>
    <div class="attachment-wrapper">
    <div v-if="showAttachments">
      <div v-if="!showSplash && numAttachments > 0">
        <div class="ellipse is-hidden-tablet-only is-hidden-desktop" @click="showOverlay = !showOverlay">
          <div class="ell" v-if="showOverlay === false">
            <span class="circle"></span>
            <span class="circle"></span>
            <span class="circle"></span>
          </div>
          <div class="close" v-if="showOverlay === true">
            <i class="fal fa-times fa-2x"></i>
          </div>
        </div>
        <div class="attachment">
          <preview :class="{'imageType': isImage}" :attachment="currentAttachment"></preview>
          <div class="background" :class="{'msOpacity': isMS}" :style="{ 'background-image': `url(${src})`}"></div>
          <overlay v-bind="{show: showOverlay && !isLocked, canAnnotate, canPreview}" @hide="showOverlay = false" @edit="editAttachment(currentIndex)" @deleting="showDeleteAttachmentModal = true"></overlay>
        </div>
        <div v-if="canDownload" class="mt-2">
          <input type="checkbox" v-model="currentAttachment.metadata.isDownloadable" /> {{ $t('projectPage.downloadAttachment') }}
        </div>
      </div>
      </div>
      <splash v-if="showSplash || numAttachments === 0" @setType="addAttachment" :context="context" :hasAttachments="numAttachments > 0"></splash>
      <blocks ref="addCarousel" @clickSelection="clickSelection" @choosePost="choosePost" @updateAttachments="updateAttachments" :attachments="attachments" :carouselPosition="currentIndex" :post="this.post"></blocks>
    </div>
    <modal-attach :parentID="_uid" @attached="handleAddAttachment" :showAvatarPicker="false"></modal-attach>
    <modal-custom v-if="maxAttachmentModal" :hasFooter="true" title="Max Attachments Reached" :text="$t('projectPage.maxAttachments')" cancelText="Cancel" @modalCancel="maxAttachmentModal = false"></modal-custom>
    <modal-custom v-if="showDeleteAttachmentModal" :hasFooter="true" :title="'Confirm delete attachment'" :text="'Are you sure you want to delete this attachment?'" :successText="'Delete'" :cancelText="'Cancel'"
    @modalSuccess="deleteAttachment" @modalCancel="showDeleteAttachmentModal = false"></modal-custom>
  </div>
</template>

<script>
import Buttons from './Buttons'
import Blocks from './Blocks'
import Splash from './Splash'

import Overlay from './Overlay/'

import Preview from '@/components/Forms/AttachmentsCarousel/Attachment'

import ModalAttach from '@/components/Modals/Attach'
import ModalCustom from '@/components/Modals/Custom'

import imageProxy from '@/libs/image-proxy'
import userAgent from '@/libs/user-agent'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'

import throttle from 'lodash/throttle'
import i18n from '@/i18n'
import state from '../../../SectionProjectView/state'
import features from '@/mixins/features'

export default {
  components: {
    Buttons,
    Blocks,
    Splash,
    Overlay,
    Preview,
    ModalAttach,
    ModalCustom
  },
  mixins: [auth, componentState, features],
  props: ['value', 'context', 'saving', 'post', 'hideButtons', 'seenText'],
  data: function () {
    return {
      attachments: this.value.slice(),
      deleted: [],
      showOverlay: true,
      showSplash: false,
      currentIndex: 0,
      maxAttachmentModal: false,
      showDeleteAttachmentModal: false,
      isInit: false
    }
  },
  computed: {
    isMS: function () {
      return userAgent.isIE11() || userAgent.isEdge()
    },
    numAttachments: function () {
      return this.attachments.length
    },
    canDownload: function () {
      return this.currentAttachment.metadata && this.currentAttachment.metadata.isDownloadable !== undefined && (this.currentAttachment.type === 'image' || this.currentAttachment.type === 'video')
    },
    currentAttachment: function () {
      return this.attachments.length > this.currentIndex ? this.attachments[this.currentIndex] : null
    },
    src: function () {
      if (this.currentAttachment && this.canPreview) {
        return imageProxy.proxy(this.currentAttachment.url, {})
      }
    },
    canPreview: function () {
      return this.isImage
    },
    canAnnotate: function () {
      return this.isImage
    },
    isImage: function () {
      if (this.currentAttachment) {
        return this.currentAttachment.type === 'image' || this.currentAttachment.type === 'whiteboard'
      }
    },
    isCreatePageAndInline: function () {
      return this.$route.params.fromTemplate && this.context === 'inline'
    },
    showButtons: function () {
      return (!this.seenText && this.context !== 'inline-update' && this.context !== 'comment') || (!this.numAttachments && !this.hideButtons)
    },
    showAttachments: function () {
      return this.seenText || this.context === 'inline-update' || this.context === 'comment'
    },
    maxAttachments: function () {
      return this.post?.maxAttachments ? this.post.maxAttachments : 12
    },
    isLocked: function () {
      const attachment = this.attachments[this.currentIndex]
      if (!attachment || this.isAnonCoordinatorRole || this.showAddCommentSection) {
        return false
      }
      return attachment.locked
    },
    projectRole: function () {
      return this._get(state.project.role, 'none')
    },
    isAnonCoordinatorRole: function () {
      return this.projectRole === 'anonCoordinator'
    },
    showAddCommentSection: function () {
      return this.hasFeature('AddComment')
    }
  },
  watch: {
    attachments: function () {
      this.$emit('input', this.attachments)
      if (this.isInit) {
        this.$emit('edited')
      } else {
        this.isInit = true
      }
    },
    value: function () {
      if (this.value.length !== this.attachments.length) {
        this.attachments = this.value.slice()
      } else {
        this.isInit = true
      }
    }
  },
  methods: {
    clickSelection: function (i) {
      this.currentIndex = i
      this.showSplash = false
    },
    choosePost: function () {
      this.showSplash = true
    },
    addAttachment: throttle(function (type) {
      if (type === 'text') {
        this.$emit('setOrToggleText')
        return
      } else {
        this.$emit('setOrToggleText', true)
      }

      if (!this.isLoggedIn) {
        let message = (this.context === 'post' ? i18n.t('projectPage.startAProject') : i18n.t('projectPage.startAProject'))
        if (this.context !== 'post') {
          message += (type === 'image' ? 'an ' : 'a ') + type
          message += ' to this project'
        }
        this.$store.dispatch('updateCreatingComment')
        return this.$store.dispatch('showLoginModal', { source: 'ADDATTACH:{PATH}', onSuccess: () => this.addAttachment(type), signupMessage: message })
      }
      if (this.attachments.length < this.maxAttachments) {
        if (type !== 'whiteboard') {
          this.$store.dispatch('showAttachModal', { type, parentID: this._uid })
        } else {
          this.$store.dispatch('showWhiteboardModal', { saveCallback: this.handleAddBoardAttachment })
        }
      } else {
        this.maxAttachmentModal = true
      }
    }, 500, { leading: true, trailing: false }),
    handleAddAttachment: function (attachment) {
      attachment.priority = this.attachments.length
      this.attachments.push(attachment)
      this.clickSelection(this.attachments.length - 1)
    },
    handleAddBoardAttachment: function (board) {
      if (board) {
        this.handleAddAttachment({
          type: 'whiteboard',
          url: board.url,
          key: board.key,
          metadata: { uuid: this.currentUser.uuid },
          parentID: 0
        })
      }
    },
    updateBoardAttachment: function (board) {
      const attachment = this.attachments[this.editPosition]
      if (!attachment || (attachment.type !== 'whiteboard' && attachment.type !== 'image')) {
        return
      }
      if (!board) {
        // only delete if it's a board, otherwise it was previously an image and we don't want to remove it
        if (attachment.type === 'whiteboard') {
          this.deleteAttachment(this.editPosition)
        }
      } else {
        this.$set(this.attachments, this.editPosition,
          {
            id: attachment.id,
            type: 'whiteboard',
            url: board.url,
            key: board.key,
            metadata: attachment.metadata || { uuid: this.currentUser.uuid },
            parentID: attachment.parentID || 0
          }
        )

        this.$emit('input', this.attachments)
      }
    },
    editAttachment: function (position, cancelCallback, annotate) {
      const attachment = this.attachments[position]
      if (!attachment) {
        return
      }
      this.editPosition = position
      this.clickSelection(position)
      if (attachment.type === 'whiteboard') {
        this.$store.dispatch('showWhiteboardModal', { key: attachment.key, saveCallback: this.updateBoardAttachment, uuid: attachment.metadata ? attachment.metadata.uuid : null, cancelCallback, annotate })
      } else if (attachment.type === 'image') {
        this.$store.dispatch('showWhiteboardModal', { image: attachment.url, saveCallback: this.updateBoardAttachment, cancelCallback, annotate })
      }
    },
    deleteAttachment: function () {
      this.showDeleteAttachmentModal = false
      const attachment = this.attachments[this.currentIndex]
      if (attachment) {
        this.attachments.splice(this.currentIndex, 1)
        if (attachment.id) {
          this.$store.dispatch('setEdited', { id: this.post.id, edited: true })
          this.deleted.push(attachment)
        }

        if (!attachment.id && attachment.type === 'whiteboard' && attachment.key) {
          this._callback('deleteBoard', attachment.key)
        }

        // if deleting last attachment, select previous
        if (this.currentIndex === this.numAttachments) {
          this.clickSelection(this.numAttachments - 1)
        }
      }
    },
    updateAttachments: function (updatedAttachments) {
      this.attachments = updatedAttachments
      this.$emit('input', this.attachments)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.attachment {
  position: relative;
  overflow: hidden;
  height: 500px;
  width: 100%;
  display: block;

  @include mobile {
    height: 200px;
  }

  .imageType {
    max-height: 500px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    @include mobile {
      max-height: 200px;
      height: 100%;
    }
  }

  .background {
    position: absolute;
    top: 0;
    height: 500px;
    width: 100%;
    filter: blur(75px) saturate(1.5);
    opacity: .4;

    @include mobile {
      height: 200px;
    }
  }

  .msOpacity {
    opacity: 0.2;
  }
}
  </style>
